import React, { FC } from "react";

import { Stack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";

import { AppleStoreIcon } from "./AppleStoreIcon/AppleStoreIcon";
import { GooglePlayStoreIcon } from "./GooglePlayStoreIcon/GooglePlayStoreIcon";
import { RouterLink } from "@Libs/Router/Components/RouterLink/RouterLink";

const _hover = { transform: "translateY(-5px)", color: "inherit" };

export const AppStoreLinks: FC = () => {
  return (
    <Stack
      spacing="1"
      flexWrap="wrap"
      direction={{ base: "column", md: "row" }}
    >
      <RouterLink _hover={_hover} route="APPLE_STORE_DOWNLOAD" reloadDocument>
        <Icon as={AppleStoreIcon} height="10" width="auto" />
      </RouterLink>
      <RouterLink
        _hover={_hover}
        route="GOOGLE_PLAY_STORE_DOWNLOAD"
        reloadDocument
      >
        <Icon as={GooglePlayStoreIcon} height="10" width="auto" />
      </RouterLink>
    </Stack>
  );
};
